import * as React from 'react';
import Helmet from 'react-helmet';
import {ResponsiveToggleProps} from './types';

export default class ResponsiveToggle extends React.Component<ResponsiveToggleProps, {}> {
  public render() {
    const metaViewportContent = this.props.off ? '' : 'width=device-width, initial-scale=1, shrink-to-fit=no';

    return (
      <Helmet>
        <meta name="viewport" content={metaViewportContent} />
      </Helmet>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ResponsiveToggle/ResponsiveToggle.tsx